import i18n from 'i18n';

function changeLanguage(newLanguage) {
	// Ensure that the language is a string
	if (!newLanguage || typeof newLanguage !== 'string') {
		return;
	}

	// Set i18next language
	i18n.changeLanguage(newLanguage);

	// Set HTML element `lang` attribute to the most
	// generic form of the language, i.e. 'en' if the
	// language is 'en-GB'
	const [genericLangIdentifier] = newLanguage.split('-');
	document.documentElement.setAttribute('lang', genericLangIdentifier);
}

export default changeLanguage;
